import * as React from "react";

import "./Spinner.scss";

interface SpinnerProps {
  loading: boolean;
}

export const Spinner = (props: SpinnerProps) => {
  return (
    <div className="spinner-container" hidden={!props.loading} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
};
